/* CART CRO — interacciones */
(function () {
  const root = document.querySelector('.ccro-page');
  if (!root) return;

  function fmt(cents) {
    const cop = Math.round(cents / 100);
    return '$' + cop.toLocaleString('es-CO').replace(/,/g, '.');
  }

  async function updateCart(updates) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      const cart = await res.json();
      // Recargamos para que se re-rendericen todos los totales y filas
      location.reload();
    } catch (e) {
      console.error('Error updating cart', e);
      location.reload();
    }
  }

  /* QTY +/- */
  root.querySelectorAll('.ccro-qty').forEach(group => {
    const input = group.querySelector('.ccro-qty-input');
    const dec = group.querySelector('[data-action="dec"]');
    const inc = group.querySelector('[data-action="inc"]');
    if (!input || !dec || !inc) return;

    let timer = null;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const key = input.dataset.key;
        const qty = parseInt(input.value, 10) || 0;
        updateCart({ [key]: qty });
      }, 350);
    };

    dec.addEventListener('click', () => {
      input.value = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
      queue();
    });
    inc.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      queue();
    });
    input.addEventListener('change', queue);
  });

  /* REMOVE */
  root.querySelectorAll('.ccro-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      updateCart({ [key]: 0 });
    });
  });
})();
